import { Component } from '@angular/core';
import { FrontEndService } from "../../services/front-end.service";

@Component({
    selector: 'app-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.scss']
})
export class HelpComponent {

    constructor(
        public frontEndService: FrontEndService,
    ) { }
}
